// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_RecalcularInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /fechamentos/recalcular/{id}
 *
 * Recalculates a fechamento's totals. No body required — id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface Fechamentos_RecalcularInput {}

registerContract('Fechamentos_RecalcularInput', {})
